@if (comments().length > 0) {
  <ul class="comment-list" [class.comment-list--divider]="showDivider()">
    @for (comment of comments(); track comment.id) {
      <li class="comment-list__item" [ocpHighlightInsertRow]="comment.id">
        <ocp-comment
          [message]="comment.message"
          [displayName]="comment.displayName ?? ''"
          [date]="comment.date ?? ''"
          [isAuthor]="comment.isAuthor ?? false"
          [colorSeed]="comment.colorSeed"
          [hyperlinks]="comment.hyperlinks ?? []"
          [attachmentLinks]="comment.attachmentLinks ?? []"
          (commentClose)="onCommentClose(comment)"
        />
      </li>
    }
  </ul>
} @else {
  <div class="comment-list__empty"></div>
}
